// extracted by mini-css-extract-plugin
export var container = "News-module--container--bff15";
export var fadeInAnimation = "News-module--fadeInAnimation--31bf9";
export var layout = "News-module--layout--0d7f7";
export var slider = "News-module--slider--2e295";